<div class="promotion-hero" [class.promotion-hero--empty]="isEmpty()">
    <div
        class="promotion-hero__banner"
        [class.promotion-hero__banner--background]="isBackground()"
        [ngStyle]="{
            'background-image': isBackground()
                ? 'url(' + backgroundUrl() + ')'
                : 'none',
            'background-size': 'cover',
            'background-position': 'center',
            'background-repeat': 'no-repeat'
        }"
    >
        <video
            *ngIf="isVideo(); else heroImage"
            class="promotion-hero__media"
            controls
            autoplay
            loop
        >
            <source [src]="videoSource()" type="video/mp4" />
        </video>
        <ng-template #heroImage>
            <picture *ngIf="promotion?.img" class="promotion-hero__media">
                <source
                    media="(max-width: 767.98px)"
                    [srcset]="promotion?.imgMobile"
                />
                <img [src]="promotion?.img" alt="Promo image" />
            </picture>
        </ng-template>
    </div>
    <section
        class="promotion-hero__reservation container-fluid"
        id="doReservation"
    >
        <fe-search-reservation
            [isNormal]="true"
            [home]="true"
        ></fe-search-reservation>
    </section>
</div>
